const pricingData = [
  { service: 'Adult first appointment', price: 105 },
  { service: 'Adult follow-up appointment', price: 70 },
  { service: 'ACC - First appointment', price: 75 },
  {
    service: 'ACC - Follow-up appointment',
    price: 50,
  },
  { service: 'Baby/child (under 15) appointment', price: 70 },
  {
    service: 'ACC - Baby/child (under 15) appointment',
    price: 50,
  },
]

const Pricing = () => {
  return (
    <main className='container mb-4 text-blue-dark lg:mb-30'>
      <h1 className='mb-10 font-serif text-5xl font-bold text-blue-dark'>Pricing</h1>
      <p className='mb-6'>Please allow between 30 and 45 minutes per consultation.</p>
      <div className='grid gap-8 lg:grid-cols-2'>
        <PricingList />
        <AccInfo />
      </div>
    </main>
  )
}

const PricingList = () => (
  <div className='mb-4 lg:mb-0 lg:pr-9'>
    {pricingData.map((item, index) => (
      <PricingItem key={item.service} {...item} isFirst={index === 0} />
    ))}
  </div>
)

const PricingItem = ({ service, price, isFirst }) => (
  <div
    className={`flex justify-between border-b-2 border-teal-primary/30 py-4 ${
      isFirst ? 'border-t-2' : ''
    }`}
  >
    <span>{service}</span>
    <span>
      <strong>${price}</strong>
    </span>
  </div>
)

const AccInfo = () => (
  <div className='mb-4 lg:mb-0 lg:pl-9'>
    <h3 className='mb-4 text-[1.75rem] font-medium leading-tight'>ACC</h3>
    <p>
      We are ACC registered and can open an ACC claim for your injury if needed. If you already have an ACC
      claim, please bring the number to your consultation. Additionally, please bring any medical notes,
      referral letters, test results, or imaging related to your injury to help us better understand your
      condition.
    </p>
  </div>
)

export default Pricing
